import React from "react";
import styles from "../../styles/layout/Header.module.css";
import { Link } from "react-router-dom";

const Header = ( props ) => {

    function addtionsClick() {
        alert("현재 부가서비스 페이지는 제작 중입니다.");
    }

    return (
        <div className={`${styles.header} ${ props.background ? styles.headerT : styles.headerW }`}>
            <div className={styles.logo}>
                <a href="/">
                    <img src={`${process.env.PUBLIC_URL}/main/1p/1p-오퍼그룹로고_수정.png`} alt="logo"></img>
                </a>
            </div>
            <nav className={styles.nav}> 
                <ul className={styles.navLinks}>
                    <li><Link to="/company">회사소개</Link></li>
                    <li><Link to="/services">서비스소개</Link></li>
                    {/* <li><a onClick={addtionsClick} href="#!">부가서비스</a></li> */}
                    <li><Link to="/news">보도자료</Link></li>
                    <li><Link to="/partner">제휴사모집</Link></li>
                    <li><Link to="/contact">문의하기</Link></li>
                </ul>
            </nav>
            <div className={styles.userInfo}>
                <img src={`${process.env.PUBLIC_URL}/main/1p/1p-회원로고_Png.png`} alt="User" className={styles.user} />
                <img src={`${process.env.PUBLIC_URL}/main/1p/1p-돋보기_Png.png`} alt="Search" className={styles.search} />
            </div>
        </div>
    );
};

export default Header;